import { render, staticRenderFns } from "./BtnOutline.vue?vue&type=template&id=6da9afe2&scoped=true&"
import script from "./BtnOutline.vue?vue&type=script&lang=js&"
export * from "./BtnOutline.vue?vue&type=script&lang=js&"
import style0 from "./BtnOutline.vue?vue&type=style&index=0&id=6da9afe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9afe2",
  null
  
)

export default component.exports